define(function (require, exports) {
    'use strict';

    // @ngInject
    exports.slidingCheckbox = function () {
        return {
            restrict: 'E',
            template: '<div class="custom-checkbox sliding-checkbox">' +
            '   <input type="checkbox" data-ng-model="checked">' +
            '   <label><span><span></span></span></label>' +
            '</div>          '
        };
    };
});



// WEBPACK FOOTER //
// ./scripts/directives/sliding-checkbox.js